import { observable, action } from 'mobx';

import UserPreferenceService from '@app/src/common/services/UserPreferenceService';

class SidebarStore {
  @observable collapsed: boolean = true;
  @observable moduleSelectorOpen: boolean = false;

  @action
  hydrate = () => {
    const saved = UserPreferenceService.getSidebarState();
    if (typeof saved.collapsed === 'boolean') {
      this.collapsed = saved.collapsed;
    }
  };

  @action
  toggle = () => {
    this.setCollapsed(!this.collapsed);
  };

  @action
  setCollapsed = (collapsed: boolean) => {
    if (this.collapsed === collapsed) {
      return;
    }
    this.collapsed = collapsed;
    UserPreferenceService.updateSidebarState({ collapsed });
  };

  @action
  openModuleSelector = () => {
    this.moduleSelectorOpen = true;
  };

  @action
  closeModuleSelector = () => {
    this.moduleSelectorOpen = false;
  };
}

export default new SidebarStore();
